import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';

import Logger from '../../functions/logging';

import ListItem from './ListItem';

import { getSubscribedGroups } from '../../api/groups';
import { getUserMonitor, updateUserMonitor } from '../../api/user';

import '../../static/home/MyList.css';

import FadeIn from '../global/FadeIn';

import * as authFns from '../../functions/auth';
import * as homeFns from '../../functions/home';
import * as studyFns from '../../functions/study';

import localeMessages from '../../locales/listItems';

import {
	setMyList,
	setUserMonitor
} from '../../redux/actions/index';

class MyList extends Component {
	constructor(props) {
		super(props);

		this.state = {
			errors: {},
			loadUserMonitor: false
		};
	}

	componentDidMount() {
		Logger.log(this.constructor.name, "componentDidMount()", this.props, this.state);

		let user_token = authFns.getToken();
		Logger.log(this.constructor.name, "componentDidMount() user_token", user_token, this.props.myList);
		if (user_token && homeFns.isMyListExpired(this.props.myListTimestamp)) {
			this.loadSubscribedGroups(user_token);
		}

		if (user_token && this.props.currentUser) {
			this.updateUserMonitor(this.props.currentUser.user_id, user_token, this.props.userPilotlyPoints, "my_list_view");
		}
	}

	componentDidUpdate() {
		let user_token = authFns.getToken();
		if (user_token && this.props.currentUser && !this.state.loadUserMonitor) {
			this.loadUserMonitor(this.props.currentUser.user_id, user_token);
		}
	}

	async loadSubscribedGroups(user_token) {
		try {
			const result = await getSubscribedGroups(user_token);
			if (result) {
				Logger.log(this.constructor.name, "loadSubscribedGroups() result", result);
				let myList = [];
				result.forEach(study => {
					if (!studyFns.isUserScreened(study)) {
						myList.push(study);
					}
				});
				this.setState({ errors: {}});
				this.props.setMyList(myList);
			}
			else {
				Logger.log(this.constructor.name, "loadSubscribedGroups() err: No result token???");
				let errors = { ...this.state.errors };
				errors["reason"] = this.props.intl.formatMessage(localeMessages.error_groups_loading_failed);
				this.setState({ errors });
			}
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.error(this.constructor.name, "loadSubscribedGroups() err", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.error_groups_loading_failed);
			this.setState({ errors });
		}
	}

	async loadUserMonitor(user_id, user_token) {
		Logger.log(this.constructor.name, "getUserMonitor(): USER TOKEN: " + user_token + " USER_ID: " + user_id);

		try {
			const results = await getUserMonitor(user_id, user_token);
			if (results) {
				Logger.log(this.constructor.name, "GET User Monitor Successful", results);
				this.setState({ loadUserMonitor: true, errors: {} }, () => {
					this.props.setUserMonitor(results);
				});
			}
			else {
				Logger.log(this.constructor.name, "GET User Monitor: No result token/user_id???");
				let errors = { ...this.state.errors };
				errors["status"] = this.props.intl.formatMessage(localeMessages.error_user_loading_failed);
				this.setState({ errors: errors, loadUserMonitor: true });

			}
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.log(this.constructor.name, "GET User Monitor Failed", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.error_user_loading_failed);
			this.setState({ errors: errors, loadUserMonitor: true });
		}
	}

	async updateUserMonitor(user_id, user_token, points, last_view) {
		Logger.log(this.constructor.name, "updateUserMonitor(): USER TOKEN: " + user_token + " USER_ID: " + user_id);

		try {
			const result = await updateUserMonitor(user_id, user_token, points, last_view);
			if (result) {
				Logger.log(this.constructor.name, "UPDATE User Monitor Successful", result);
				this.setState({ errors: {} });
				this.props.setUserMonitor(result);
			}
			else {
				Logger.log(this.constructor.name, "UPDATE User Monitor: No result token/user_id???");
				let errors = { ...this.state.errors };
				errors["status"] = this.props.intl.formatMessage(localeMessages.error_user_update_failed);
				this.setState({ errors: errors });

			}
		}
		catch (error) {
			Logger.log(this.constructor.name, "UPDATE User Monitor Failed", error);
			let errors = { ...this.state.errors };
			errors["status"] = this.props.intl.formatMessage(localeMessages.error_user_update_failed);
			this.setState({ errors: errors });
		}
	}

	renderItems() {
		if ((!this.props.myList || !this.props.myList.length) && this.state.loading) {
			return (
				<div className="pilotly-home-mylist-empty"></div>
			);
		}
		if (!this.props.myList || !this.props.myList.length) {
			return (
				<div className="pilotly-home-mylist-empty">
					<FormattedMessage
						id="mylist.message.no_videos"
						defaultMessage={`No videos selected. Subscribe to a study from your activity list.`}
					/>
				</div>
			);
		}
		return this.props.myList.map((study, index) => {
			return (
				<ListItem key={"mylist-item-" + study._id.valueOf()}
					{...this.props}
					index={index}
					item={study}
				/>
			);
		});
	}

	render() {
		Logger.log(this.constructor.name, "render()", this.props, this.state);

		return (
			<FadeIn>
				<div className="pilotly-home-mylist">
					{this.renderItems()}
				</div>
			</FadeIn>
		);
	}
}

function mapStateToProps(state) {
	Logger.log(this.constructor.name, "mapStateToProps()", state);
	return {
		currentUser: state.currentUser.currentUser,
		userMonitor: state.currentUser.userMonitor,
		userPilotlyPoints: state.currentUser.userPilotlyPoints,
		myList: state.homeLists.myList,
		myListTimestamp: state.homeLists.myListTimestamp,
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		setMyList,
		setUserMonitor
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(MyList));



// WEBPACK FOOTER //
// ./src/components/home/MyList.js